/*
    작성자 : 박승호
    작성일자: 2025-02-05
    기능 : 전역 테마 컬러 및 기본 베이스 스타일 정의
*/

import { createGlobalStyle } from 'styled-components';

const styled = { createGlobalStyle };
const GlobalTheme = styled.createGlobalStyle`
  /* System Color ( Sub Color ) */
  :root {
    --blue: #3e97ff;
    --blue-60: rgba(62, 152, 255, 0.8);
    --blue-darker: #0095e8;
    --blue-lighter: #f1faff;

    --green: #50cd89;
    --green-60: rgba(72, 216, 158, 0.8);
    --green-darker: #47be7d;
    --green-lighter: #e8fff3;

    --orange: #ffc700;
    --orange-60: rgba(251, 146, 60, 0.8);
    --orange-darker: #f1bc00;
    --orange-lighter: #fff8dd;

    --red: #f1416c;
    --red-60: rgba(244, 42, 63, 0.8);
    --red-darker: #d9214e;
    --red-lighter: #fff5f8;
    --red-deep: #b3000c;

    --lightGray: #dbdfe9;
    --lightGray-darker: #b5b5c3;
    --lightGray-lighter: #f9f9f9;

    --darkGray: #071437;
    --darkGray-darker: #050f29;
    --darkGray-lighter: #f1f1f2;

    --white: #ffffff;
    --black: #000000;

    --gray-50: #f9fafb;
    --gray-100: #f3f4f6;
    --gray-200: #e5e7eb;
    --gray-300: #d1d5db;
    --gray-400: #9ca3af;
    --gray-500: #6b7280;
    --gray-600: #4b5563;
    --gray-700: #374151;
    --gray-800: #1f2937;
    --gray-900: #111827;
    --gray-950: #030712;

    --slate-50: #f9fafb;
    --slate-100: #f9f9f9;
    --slate-200: #f1f1f2;
    --slate-300: #dbdfe9;
    --slate-400: #b5b5c3;
    --slate-500: #99a1b7;
    --slate-600: #78829d;
    --slate-700: #4b5675;
    --slate-800: #252f4a;
    --slate-900: #071437;
    --slate-950: #030712;

    --zinc-50: #fafafa;
    --zinc-100: #f4f4f5;
    --zinc-200: #e4e4e7;
    --zinc-300: #d4d4d8;
    --zinc-400: #a1a1aa;
    --zinc-500: #71717a;
    --zinc-600: #52525b;
    --zinc-700: #3f3f46;
    --zinc-800: #27272a;
    --zinc-900: #18181b;
    --zinc-950: #09090b;

    --blue-50: #eff6ff;
    --blue-100: #dbeafe;
    --blue-200: #bfdbfe;
    --blue-300: #93c5fd;
    --blue-400: #60a5fa;
    --blue-500: #3b82f6;
    --blue-600: #2563eb;
    --blue-700: #1d4ed8;
    --blue-800: #1e40af;
    --blue-900: #1e3a8a;
    --blue-950: #172554;

    --green-50: #f0fdf4;
    --green-100: #dcfce7;
    --green-200: #bbf7d0;
    --green-300: #86efac;
    --green-400: #4ade80;
    --green-500: #22c55e;
    --green-600: #16a34a;
    --green-700: #15803d;
    --green-800: #166534;
    --green-900: #14532d;
    --green-950: #052e16;

    --amber-50: #fffbeb;
    --amber-100: #fef3c7;
    --amber-200: #fde68a;
    --amber-300: #fde047;
    --amber-400: #fbbf24;
    --amber-500: #f59e0b;
    --amber-600: #d97706;
    --amber-700: #b45309;
    --amber-800: #92400e;
    --amber-900: #78350f;
    --amber-950: #451a03;

    --red-50: #fef2f2;
    --red-100: #fee2e2;
    --red-200: #fecaca;
    --red-300: #fca5a5;
    --red-400: #f87171;
    --red-500: #ef4444;
    --red-600: #dc2626;
    --red-700: #b91c1c;
    --red-800: #991b1b;
    --red-900: #7f1d1d;
    --red-950: #450a0a;

    --rose-50: #fff1f2;
    --rose-100: #ffe4e6;
    --rose-200: #fecdd3;
    --rose-300: #fda4af;
    --rose-400: #fb7185;
    --rose-500: #f43f5e;
    --rose-600: #e11d48;
    --rose-700: #be123c;
    --rose-800: #9f1239;
    --rose-900: #881337;
    --rose-950: #4c0519;

    --violet-50: #f5f3ff;
    --violet-100: #ede9fe;
    --violet-200: #ddd6fe;
    --violet-300: #c4b5fd;
    --violet-400: #a78bfa;
    --violet-500: #8b5cf6;
    --violet-600: #7c3aed;
    --violet-700: #6d28d9;
    --violet-800: #5b21b6;
    --violet-900: #4c1d95;
    --violet-950: #2e1065;

    --pink-50: #fdf2f8;
    --pink-100: #fce7f3;
    --pink-200: #fbcfe8;
    --pink-300: #f9a8d4;
    --pink-400: #f472b6;
    --pink-500: #ec4899;
    --pink-600: #db2777;
    --pink-700: #be185d;
    --pink-800: #9d174d;
    --pink-900: #831843;
    --pink-950: #500724;

    --emerald-50: #ecfdf5;
    --emerald-100: #d1fae5;
    --emerald-200: #a7f3d0;
    --emerald-300: #6ee7b7;
    --emerald-400: #34d399;
    --emerald-500: #10b981;
    --emerald-600: #059669;
    --emerald-700: #047857;
    --emerald-800: #065f46;
    --emerald-900: #064e3b;
    --emerald-950: #022c22;

    --teal-50: #f0fdfa;
    --teal-100: #ccfbf1;
    --teal-200: #99f6e4;
    --teal-300: #5eead4;
    --teal-400: #2dd4bf;
    --teal-500: #14b8a6;
    --teal-600: #0d9488;
    --teal-700: #0f766e;
    --teal-800: #115e59;
    --teal-900: #134e4a;
    --teal-950: #042f2e;

    --yellow-50: #fefce8;
    --yellow-100: #fef9c3;
    --yellow-200: #fef08a;
    --yellow-300: #fde047;
    --yellow-400: #facc15;
    --yellow-500: #eab308;
    --yellow-600: #ca8a04;
    --yellow-700: #a16207;
    --yellow-800: #854d0e;
    --yellow-900: #713f12;
    --yellow-950: #422006;

    --orange-50: #fff7ed;
    --orange-100: #ffedd5;
    --orange-200: #fed7aa;
    --orange-300: #fdba74;
    --orange-400: #fb923c;
    --orange-500: #f97316;
    --orange-600: #ea580c;
    --orange-700: #c2410c;
    --orange-800: #9a3412;
    --orange-900: #7c2d12;
    --orange-950: #431407;

    --lime-50: #f7fee7;
    --lime-100: #ecfccb;
    --lime-200: #d9f99d;
    --lime-300: #bef264;
    --lime-400: #a3e635;
    --lime-500: #84cc16;
    --lime-600: #65a30d;
    --lime-700: #4d7c0f;
    --lime-800: #3f6212;
    --lime-900: #365314;
    --lime-950: #1a2e05;

    --sky-50: #f0f9ff;
    --sky-100: #e0f2fe;
    --sky-200: #bae6fd;
    --sky-300: #7dd3fc;
    --sky-400: #38bdf8;
    --sky-500: #0ea5e9;
    --sky-600: #0284c7;
    --sky-700: #0369a1;
    --sky-800: #075985;
    --sky-900: #0c4a6e;
    --sky-950: #082f49;

    --indigo-50: #eef2ff;
    --indigo-100: #e0e7ff;
    --indigo-200: #c7d2fe;
    --indigo-300: #a5b4fc;
    --indigo-400: #818cf8;
    --indigo-500: #6366f1;
    --indigo-600: #4f46e5;
    --indigo-700: #4338ca;
    --indigo-800: #3730a3;
    --indigo-900: #312e81;
    --indigo-950: #1e1b4b;
  }

  /* Common */
  :root {
    /* Widget */
    --widget-primary: #6360f0;
    --widget-secondary: #3ec5fb;

    --widget-status-red: #f44336;
    --widget-status-blue: #2196f3;
    --widget-status-green: #4caf50;
    --widget-status-yellow: #ff9e07;
    --widget-status-tonal-red: rgba(239, 68, 68, 0.1);
    --widget-status-tonal-blue: rgba(59, 130, 246, 0.1);
    --widget-status-tonal-green: rgba(34, 197, 94, 0.1);
    --widget-status-tonal-yellow: rgba(255, 158, 7, 0.1);

    --widget-font-size-title-sm: 1.25rem;
    --widget-font-size-title: 1.625rem;
    --widget-font-size-xs: 1rem;
    --widget-font-size-sm: 1.125rem;
    --widget-font-size-base: 1.25rem;
    --widget-font-size-lg: 1.5rem;
    --widget-font-size-xl: 1.875rem;
    --widget-font-size-2xl: 2.25rem;
    --widget-font-size-3xl: 3rem;
    --widget-font-size-4xl: 3.375rem;
    --widget-font-size-5xl: 4.5rem;
    --widget-font-size-6xl: 5.25rem;
    --widget-font-size-7xl: 6rem;
    --widget-font-size-8xl: 7.5rem;
    --widget-font-size-9xl: 8.25rem;
    --widget-font-size-10xl: 9rem;
    --widget-padding-inside: 1rem;
  }

  /* Theme Light */
  :root {
    /* Brand Color */
    --primary: #3b82f6;

    /* Scroll Color */
    --scrollbar: #e4e4e7;

    /* Tonal Palette */
    --tonal: #f3f4f6;
    --tonal-light: #fafafa;
    --tonal-deep: #e5e7eb;
    --tonal-blue: #eef2ff;
    --tonal-light-blue: #bfdbfe;
    --tonal-deep-blue: #e0e7ff;
    --tonal-green: #f0fdf4;
    --tonal-deep-green: #dcfce7;
    --tonal-violet: #f5f3ff;
    --tonal-amber: #fffbeb;
    --tonal-orange: #fff7ed;
    --tonal-red: #fff5f8;
    --tonal-light-red: #fecaca;
    --tonal-deep-red: #fee2e2;

    /* Text Color */
    --text-primary: #18181b;
    --text-secondary: #52525b;
    --text-tertiary: #71717a;
    --text-quaternary: #52525b;
    --text-disabled: #a1a1aa;
    --text-reverse: #fff;

    /* Outline Color */
    --outline: #e4e4e7;
    --outline-secondary: #f1f1f1;
    --outline-em: #d4d4d8;
    --outline-focus: #868686;
    --outline-status: #e5e7eb;

    /* Fill Color */
    --filled-blue-light: #60a5fa;
    --filled-blue-deep: #2563eb;
    --filled-blue-dark: #1e40af;
    --filled-red: #f43f5e;
    --filled-red-deep: #e11d48;
    --filled-red-dark: #9f1239;
    --filled-green: #10b981;
    --filled-green-light: #34d399;
    --filled-green-deep: #059669;
    --filled-orange: #f97316;
    --filled-violet: #8b5cf6;
    --filled-violet-deep: #7c3aed;
    --filled-pink: #ec4899;
    --filled-teal: #14b8a6;
    --filled-amber: #f59e0b;
    --filled-amber-light: #fbbf24;
    --filled-amber-deep: #d97706;
    --filled-yellow: #eab308;
    --filled-sky: #0ea5e9;
    --filled-indigo: #6366f1;
    --filled-indigo-light: #818cf8;
    --filled-indigo-deep: #4f46e5;
    --filled-lime: #84cc16;
    --filled-slate: #99a1b7;
    --filled-slate-light: #b5b5c3;
    --filled-slate-deep: #78829d;

    /* FONT */
    --font-regular: 400;
    --font-medium: 500;
    --font-semibold: 600;
    --font-bold: 700;
    --font-extrabold: 800;

    /* COMMON */
    --board: #fff;
    --background: #fcfcfc;
    --trans: #fff;
    --btn-text: #f4f4f5;

    /* ETC */
    --badge-primary-text: #3b82f6;
    --badge-primary-bg: #eff6ff;
    --bw: #111827;
    --bw-inverse: rgba(255, 255, 255, 0.9);
    --trans-bw-reverse: rgba(0, 0, 0, 0.3);
    --alpha-17: rgba(0, 0, 0, 0.1);
    --alpha-15: rgba(255, 255, 255, 0.15);
    --alpha-25: rgba(255, 255, 255, 0.25);
    --alpha-50: rgba(255, 255, 255, 0.5);
    --alpha-75: rgba(255, 255, 255, 0.75);
    --inverse-alpha-05: rgba(0, 0, 0, 0.05);
    --inverse-alpha-25: rgba(0, 0, 0, 0.25);
    --inverse-alpha-50: rgba(0, 0, 0, 0.5);
    --inverse-alpha-75: rgba(0, 0, 0, 0.75);
    --calendar-shadow: rgba(220, 220, 220, 0.5);
    --weather-bg: #3e97ff;
    --weather-bg-2: #0194b5;
    --weather-sub-bg: #2c80fd;
    --weather-sub-bg-2: #94bfff;
    --selected-primary: #3b82f6;
    --selected-secondary: #3b82f6;
    --selected-text: #2563eb;
    --skeleton-bg: #f0f0f0;
    --skeleton-base: #e0e0e0;
    --skeleton-highlight: #f5f5f5;
    --side-sub: #fcfcfc;
    --rdr-day-end-preview: 'multiply';
    --travel-weather-sub-bg: #1e3a63;
    --op-bg-15: rgba(0, 0, 0, 0.15);
    --op-bg-3: rgba(0, 0, 0, 0.3);
    --holiday-bg: var(--red-100);

    /* board widget */
    --widget-text-primary: #000;
    --widget-text-secondary: #444444;
    --widget-text-tertiary: #777777;
    --widget-text-primary-reverse: #ffffff;

    --widget-theme-tonal-blue: rgba(79, 107, 232, 0.1);
    --widget-theme-tonal-lightblue: rgba(64, 198, 255, 0.1);

    /* Widget */
    --widget-board-bg: #c1ccdf;
    --widget-bg: #ffffff;
    --widget-sub-bg: #f8f8f8;
    --widget-sub-text: #888888;
    --widget-accent-text: #d5d5d5;
    --widget-weather-bg: var(--widget-primary);
    --widget-weather-item-bg: var(--widget-sub-bg);
    --widget-weather-item-sub-bg: rgba(255, 255, 255, 0.15);

    --widget-theme-darkblue: #2f374c;
    --widget-theme-navy: #031339;
    --widget-theme-tonal-darkblue: rgba(52, 77, 173, 0.1);
  }

  /* Theme Dark */
  [data-theme='dark'] {
    /* Brand Color */
    --scrollbar: #4b5563;

    /* Tonal Palette */
    --tonal: #27272a;
    --tonal-light: #131313;
    --tonal-deep: #374151;
    --tonal-blue: #212e48;
    --tonal-light-blue: #93c5fd;
    --tonal-deep-blue: #172554;
    --tonal-green: #1c3238;
    --tonal-deep-green: #16a34a;
    --tonal-violet: #2e1065;
    --tonal-amber: #451a03;
    --tonal-orange: #332800;
    --tonal-red: #3a2434;
    --tonal-light-red: #f87171;
    --tonal-deep-red: #dc2626;

    /* Text Color */
    --text-primary: #e4e4e7;
    --text-secondary: #b5b5c3;
    --text-tertiary: #a1a1aa;
    --text-quaternary: #d4d4d8;
    --text-disabled: #71717a;
    --text-reverse: #000;

    /* Outline Color */
    --outline: #3f3f46;
    --outline-secondary: #2f2f2f;
    --outline-em: #52525b;
    --outline-focus: #6f6f7d;
    --outline-status: none;

    /* Fill Color */
    --filled-blue-light: #3b82f6;
    --filled-blue-deep: #2563eb;
    --filled-blue-dark: #1d4ed8;
    --filled-red: #be123c;
    --filled-red-deep: #9f1239;
    --filled-red-dark: #e11d48;
    --filled-green: #16a34a;
    --filled-green-light: #22c55e;
    --filled-green-deep: #15803d;
    --filled-orange: #ea580c;
    --filled-violet: #8b5cf6;
    --filled-violet-deep: #7c3aed;
    --filled-pink: #db2777;
    --filled-teal: #0d9488;
    --filled-amber: #d97706;
    --filled-amber-light: #f59e0b;
    --filled-amber-deep: #b45309;
    --filled-yellow: #ca8a04;
    --filled-sky: #0284c7;
    --filled-indigo: #4f46e5;
    --filled-indigo-light: #6366f1;
    --filled-indigo-deep: #4338ca;
    --filled-lime: #65a30d;
    --filled-slate: #78829d;
    --filled-slate-light: #99a1b7;
    --filled-slate-deep: #4b5675;

    /* FONT */
    --font-regular: 300;
    --font-medium: 400;
    --font-semibold: 500;
    --font-bold: 600;

    /* COMMON */
    --board: #1c1c1c;
    --background: #131313;
    --trans: #c8c8c8;
    --btn-text: #e4e4e7;

    /* ETC */
    --badge-primary-text: #bfdbfe;
    --badge-primary-bg: #1e3a8a;
    --bw: #f3f4f6;
    --bw-inverse: #030712;
    --trans-bw-reverse: rgba(255, 255, 255, 0.3);
    --alpha-17: rgba(0, 0, 0, 0.7);
    --alpha-15: rgba(0, 0, 0, 0.15);
    --alpha-25: rgba(0, 0, 0, 0.25);
    --alpha-50: rgba(0, 0, 0, 0.5);
    --alpha-75: rgba(0, 0, 0, 0.75);
    --inverse-alpha-05: rgba(255, 255, 255, 0.05);
    --inverse-alpha-25: rgba(255, 255, 255, 0.25);
    --inverse-alpha-50: rgba(255, 255, 255, 0.5);
    --inverse-alpha-75: rgba(255, 255, 255, 0.75);
    --calendar-shadow: rgba(0, 0, 0, 0.5);
    --weather-bg: #2f323e;
    --weather-bg-2: #000b31;
    --weather-sub-bg: #1f2027;
    --weather-sub-bg-2: #0c0d10;
    --selected-primary: #0095e8;
    --selected-secondary: #0095e8;
    --selected-text: #93c5fd;
    --skeleton-bg: #1e1e1e;
    --skeleton-base: #2a2a2a;
    --skeleton-highlight: #3a3a3a;
    --side-sub: #1e1e1e;
    --rdr-day-end-preview: 'lighten';
    --travel-weather-sub-bg: #1f2027;
    --op-bg-15: rgba(255, 255, 255, 0.15);
    --op-bg-3: rgba(255, 255, 255, 0.3);
    --holiday-bg: var(--tonal-red);

    /* board widget */
    --board-bg: #101010;
    --widget-bg: #222631;
    --widget-text-primary: #ffffff;
    --widget-text-secondary: #fafafa;
    --widget-text-tertiary: #a1a9c0;
    --widget-text-primary-reverse: #101010;

    --widget-theme-navy: #4a5a8a; /* 다크모드에서 더 밝은 navy 색상 */
    --widget-theme-tonal-blue: rgba(79, 107, 232, 0.1);
    --widget-theme-tonal-lightblue: rgba(64, 198, 255, 0.2);

    /* Widget */
    --widget-board-bg: #101010;
    --widget-bg: #222631;
    --widget-sub-bg: #2f374c;
    --widget-sub-text: #a1a9c0;
    --widget-accent-text: #444444;
    --widget-weather-bg: var(--widget-bg);
    --widget-weather-item-bg: rgba(0, 0, 0, 0.2);
    --widget-weather-item-sub-bg: rgba(0, 0, 0, 0.3);
  }

  :root {
    --scroll-width: 12px;
  }

  /* Mobile */
  @media screen and (max-width: 768px) {
    :root {
      --scroll-width: 0;
    }
  }
`;

export default GlobalTheme;
